import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from 'react-router-dom';
import useAuthFlow from "../Hooks/use-auth-flow";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.user?.isAuthenticated);
  const { triggerAuth } = useAuthFlow();

if (!isAuthenticated) {
  triggerAuth("signin");

  return (
    <Navigate
      to="/"
      replace
      state={{ redirectTo: location.pathname }}
    />
  );
}

  return children;
};

export default ProtectedRoute;
